module.exports = __webpack_public_path__ + "img/ic_amenity.ef37370c.svg";